<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb" class="barra-ubicacion-nav">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">Ventas</li>
                <li class="breadcrumb-item active li-actualizar-datos" aria-current="page" title="Actualizar datos de venta" v-if="general.otros.app_modo=='online'" @click=obtener_recursos>
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            <div style="width: 100%; display:flex; justify-content:center;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    Nueva venta
                                </button>
                            </div>       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal-registro">
            <div class="modal-dialog modal-xl" style="width:90%;">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        <!-- <h5 v-if="datos.registro.id===''" class="modal-title">Crear venta</h5>
                        <h5 v-else class="modal-title">Editar venta</h5> -->

                        <template v-if="['','activo'].includes(datos.registro.estado)">
                            <h5 v-if="datos.registro.id===''" class="modal-title">Crear venta</h5>
                            <h5 v-else class="modal-title">Editar venta</h5>
                        </template>
                        <template v-else>
                            <h5>Datos de la venta</h5>
                        </template>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">                                

                                <div class="form-group col-md-12">
                                    <label for="inputEmail4">Materiales de la venta:</label>                                    
                                    <div>
                                        <template v-for='(item,index) in datos.registro.productos' :key=index>
                                            <div v-if="item.estado=='activo'" class="form-row contenedor-producto">  

                                                <div class="form-group col-md-1" style="margin:0px; display:flex; align-items:center;">                                                    
                                                    <label for="inputEmail4">{{item.posicion}}</label>
                                                </div>
                                                <div class="form-group col-md-10" style="margin:0px;">

                                                    <div class="form-row">  
                                                        <div class="form-group col-md-3 col-12">

                                                            <div v-if=" item.productos_id=='' ">                                                            
                                                                <label for="inputEmail4" class="titulo-campo">Material:</label>                                                            
                                                                <select class="form-control input-3d" :id="'select_material_'+index" data-live-search="true" v-model=item.productos_id @change=material_seleccionado(index)>
                                                                    <option value="" disabled>Seleccione</option>
                                                                    <option v-for='(p,p_index) in datos.productos.todos' :key=p_index :value=p.id>
                                                                        {{p.nombre}}
                                                                    </option>                            
                                                                </select>
                                                            </div>
                                                            <div v-else style="height:100%; width:100%; display:flex; flex-wrap:wrap; align-items:center;">
                                                                <label for="inputEmail4" class="titulo-campo">Material:</label>
                                                                <template v-for='(p,p_index) in datos.productos.todos'>
                                                                    <p v-if="p.id==item.productos_id" :key=p_index class="material-nombre" @click="regresar_selecionar_producto(index)" style="width:100%; text-align:center;">
                                                                        {{p.nombre}}
                                                                    </p>
                                                                </template>
                                                            </div>

                                                        </div>
                                                        
                                                        <div class="form-group col-md-3 col-6">
                                                            <label for="inputEmail4" class="titulo-campo">Cantidad (Kg):</label>
                                                            <input type="number" :id="'input_cantidad_'+index" class="form-control input-3d" v-model=item.cantidad @input=calcular_producto_total(index) @keydown=cantidad_evento_key($event,index)>
                                                        </div>

                                                        <div class="form-group col-md-3 col-6">
                                                            <label for="inputEmail4" class="titulo-campo">Precio:</label>
                                                            <input type="number" :id="'precio_cantidad_'+index" class="form-control input-3d" v-model=item.precio @input=calcular_producto_total(index) @keydown=precio_evento_key>
                                                        </div>
                                                        <div class="form-group col-md-3 col-12">
                                                            <label for="inputEmail4" class="titulo-campo">Total:</label>
                                                            <input type="number" class="form-control input-3d" v-model=item.total @input=calcular_registro_venta_total>
                                                        </div>

                                                        <!-- <div class="form-group col-md-3 col-12">
                                                            <label for="inputEmail4">Origen del material:</label>
                                                            <select class="form-control input-3d" v-model=item.origen>

                                                                <option value="" disabled>Seleccione</option>
                                                                <option value="compras" >Inventario Compras </option>
                                                                <option value="bodega"  >Inventario Bodega </option>

                                                            </select>

                                                        </div> -->
                                                    </div>
                                                    
                                                </div>
                                                <div class="form-group col-md-1" style="margin:0px;">
                                                    <div style="display:flex; justify-content:right; height:100%; align-items:center;">
                                                        <button class='boton-3d-danger' v-if="['','activo'].includes(datos.registro.estado)" @click="boton_remover_producto(index)">
                                                            <i class='fa fa-times' aria-hidden='true'></i>
                                                        </button>
                                                    </div>
                                                </div>                                                                                                                                                         

                                            </div>
                                        </template>
                                    </div>
                                    
                                </div>   

                                <div class="form-group col-md-4">
                                    <button type="button" class="boton-3d-success" v-if="['','activo'].includes(datos.registro.estado) && datos.registro_cargando==false" @click="agregar_producto('')">
                                        <i class='fa fa-plus' aria-hidden='true'></i>    
                                        Agregar material
                                    </button>
                                </div>

                                <div class="form-group col-md-8">
                                    <label for="inputEmail4">Cliente:</label>                                    
                                    <select class="form-control input-3d" v-model=datos.registro.clientes_id disabled>
                                        <option value="" disabled>Seleccione</option>
                                        <option v-for='(c,c_index) in datos.clientes.todos' :key=c_index :value=c.id>
                                            {{ c.nombre }} {{c.apellido_paterno}} {{c.apellido_materno}} -
                                            
                                            <template v-if="c.tipo=='ambos'"> 
                                                Mayoreo y Menudeo
                                            </template>
                                            <template v-else>
                                                {{c.tipo}}
                                            </template>
                                            
                                        </option>
                                    </select>
                                </div>


                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Total de venta :</label>
                                    <p style="font-size:2em;"> {{  formato_moneda(datos.registro.total_venta) }} </p>
                                </div>

                                <div class="form-group col-md-8">
                                
                                    <div class="row">

                                        <!-- <div class="form-group col-md-3">
                                            <label for="inputEmail4">Pago pendiente :</label>
                                            <input type="checkbox" class="form-control" v-model=datos.registro.pago_pendiente :disabled="datos.registro.estado=='finalizado'">
                                        </div> -->

                                        <template v-if="datos.registro.pago_pendiente==false">
                                            <div class="form-group col-md-3">
                                                <label for="inputEmail4">Forma de pago:</label>
                                                <select class="form-control input-3d" v-model=datos.registro.forma_pago @change="forma_pago_seleccionado" disabled>
                                                    <option value="" disabled>Seleccione</option>
                                                    <option value="efectivo">Efectivo</option>
                                                    <!-- <option value="transferencia">Transferencia</option>
                                                    <option value="efectivo_transferencia">Ambos</option> -->
                                                </select>
                                            </div>                                                                         
                                        </template>


                                        <div class="form-group col-md-3 col-6">
                                            <label for="inputEmail4">Fecha de creación:</label> 
                                            <input type="date" class="form-control input-3d" v-model=datos.registro.fecha_creacion>
                                        </div>

                                        <div class="form-group col-md-3 col-6">
                                            <label for="inputEmail4">Tipo de venta:</label> 
                                            <select class="form-control input-3d" v-model=datos.registro.tipo>
                                                <template v-if="general.roles.rol1">
                                                    <option value="mayoreo">Mayoreo</option>
                                                </template>

                                                <option value="menudeo">Menudeo</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>


                                <template v-if="datos.registro.pago_pendiente==false && datos.registro.forma_pago=='efectivo_transferencia'">
                                    <div class="form-group col-md-6">
                                        <label for="inputEmail4">Cantidad efectivo:</label>
                                        <input type="number" class="form-control input-3d" v-model=datos.registro.forma_pago_efe_tra_cant_efec @input="calcular_forma_pago_efec_tran_total">
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="inputEmail4">Cantidad transferencia:</label>
                                        <input type="number" class="form-control input-3d" v-model=datos.registro.forma_pago_efe_tra_cant_tran @input="calcular_forma_pago_efec_tran_total">                                        
                                    </div>
                                    <div class="form-group col-md-12" v-if="(datos.registro.productos).length>0">
                                        <p v-if="datos.forma_pago_efec_tran_cantidad_valida" id="leyenda-metodo-pago-ambos-verde">Cantidad en efectivo + transferencia correcto</p>
                                        <p v-else id="leyenda-metodo-pago-ambos-rojo">Cantidad en efectivo + transferencia debe ser igual al total final</p>
                                    </div>
                                </template>
                                                            
                                <!-- <div class="form-group col-md-3">
                                    <label for="inputEmail4">Pago pendiente :</label>
                                    <input type="checkbox" class="form-control" v-model=datos.registro.pago_pendiente :disabled="datos.registro.estado=='finalizado'">
                                </div> -->                                
                                   

                                
                                
                            </div>  
                            
                            <template v-if="datos.registro.pago_pendiente==false">
                            
                                <div class="form-row" v-if="['transferencia','efectivo_transferencia'].includes(datos.registro.forma_pago)">

                                    <div class="form-group col-md-6 col-12">
                                        <template v-if="['','activo'].includes(datos.registro.estado)">

                                            <label for="inputEmail4">Cuentas Disponibles :</label>                                    
                                            <select id="select_cuentas_disponibles" class="form-control input-3d" v-model=datos.cuentas_bancarias.seleccionado @change="cuenta_bancaria_seleccionado('')">
                                                <option value="" disabled>Seleccione</option>
                                                <option v-for='(c,c_index) in datos.cuentas_bancarias.todos' :key=c_index :value="c.cuentas_bancarias_id">
                                                    {{ c.banco_nombre }}
                                                    {{ c.cuenta }}
                                                    {{ c.titular }}
                                                    {{ general_formato_moneda(c.ultimo_total) }}
                                                    
                                                </option>
                                            </select>

                                        </template>

                                    </div>

                                    <div class="form-group col-md-6 col-12"></div>

                                    <div class="form-group col-md-8 col-12">
                                        <label for="inputEmail4">Cuentas seleccionadas :</label>                                    
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Banco</th>
                                                    <th scope="col">Cuenta</th>
                                                    <th scope="col">Titular</th>
                                                    <th scope="col">Cantidad a transferir</th>
                                                    <th scope="col"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for='(c,c_index) in datos.registro.transferencias'>

                                                    <tr v-if="c.estado=='activo'" :key=c_index>

                                                        <th scope="row">{{c_index+1}}</th>
                                                        <td> 
                                                            <!--<img v-if="c.banco=='bancoppel'" style="width:150px;" src="@/lobato/general/img/bancoppel.png">-->
                                                            {{ c.banco_nombre }}
                                                        </td>
                                                        <td>{{ c.cuenta }}</td>
                                                        <td>{{ c.titular }}</td>
                                                        <td>

                                                            <div class="contenedor-check-cantidad">        

                                                                <template v-if="['','activo'].includes(datos.registro.estado)">
                                                                    <input :id="'input_cuenta_cantidad_'+c_index" type="number" class="form-control input-3d" v-model=c.cantidad>
                                                                </template>
                                                                <template v-else>
                                                                    <input :id="'input_cuenta_cantidad_'+c_index" type="number" class="form-control input-3d" :value=c.cantidad disabled>
                                                                </template>

                                                            </div>

                                                        </td>
                                                        <td>

                                                            <button v-if="['','activo'].includes(datos.registro.estado)" class='boton-3d-danger' type="button" @click=remover_transferencia(c_index)>
                                                                <i class='fa fa-times' aria-hidden='true'></i>
                                                            </button>
                                                        </td>

                                                    </tr>
                                                </template>

                                            </tbody>
                                        </table>
                                    </div>

                                </div>

                            </template>

                            <div class="form-row">                                
                                <div class="form-group col-md-12">
                                    <label for="inputEmail4">Descripcion de la venta:</label>
                                    <textarea class="form-control input-3d" maxlength="400" rows="2" v-model=datos.registro.descripcion></textarea>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">

                        <template v-if="general.otros.app_modo=='offline'">
                            <button type="button" class="boton-3d-success" @click="guardar_localmente">
                                Guardar localmente
                            </button> 
                        </template>
                        <template v-if="general.otros.app_modo=='online'">

                            <template v-if="['','activo'].includes(datos.registro.estado) && datos.registro_cargando==false">
                                <button type="button" class="boton-3d-success" @click="enviar_datos('finalizar')">
                                    Finalizar venta
                                </button>
                                <button type="button" class="boton-3d-success" @click="enviar_datos('guardar')">
                                    <template v-if="datos.registro.id===''">Guardar venta</template>
                                    <template v-else>Editar venta</template>
                                </button>
                            </template>

                        </template>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->

        <!-- inicio modal_pago_pendiente -->
        <div class="modal fade bd-example-modal-lg" id="modal_pago_pendiente">
            <div class="modal-dialog modal-xl" style="width:90%;">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        <!-- <h5 v-if="datos.registro.id===''" class="modal-title">Crear venta</h5>
                        <h5 v-else class="modal-title">Editar venta</h5> -->
                        
                        <h5>
                            Pago pendiente de la venta no : 
                            {{ datos.registro_pago_pendiente.no }}
                        </h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">
                                
                                <div class="form-group col-md-4 col-6">
                                    <label for="inputEmail4">Total venta:</label> 
                                    <p>
                                        {{ general_formato_moneda(datos.registro_pago_pendiente.total_venta) }}
                                    </p>
                                </div>
                                <div class="form-group col-md-4 col-6">
                                    <label for="inputEmail4">Saldo restante:</label> 
                                    <p>
                                        {{ general_formato_moneda(datos.registro_pago_pendiente.pago_pendiente_restante) }}
                                    </p>
                                </div> 
                                <div class="form-group col-md-4 col-6">
                                    <label for="inputEmail4">Fecha de creación:</label> 
                                    <p>
                                        {{ datos.registro_pago_pendiente.fecha_creacion }}
                                    </p>
                                </div>
                                <div class="form-group col-md-12 col-12">
                                    <label for="inputEmail4">Descripción:</label> 
                                    <p>
                                        {{ datos.registro_pago_pendiente.descripcion }}
                                    </p>
                                </div>   
                                
                                <div class="form-group col-md-12" style="min-height:140px; overflow:scroll;">
                                    <label for="inputEmail4">Historial de pagos</label>
                                    <table class="table table-hover">
                                        <thead>                                            
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Fecha</th>
                                                <th scope="col">Forma de pago</th>
                                                <th scope="col">Saldo antes de pago</th>
                                                <th scope="col">Pago</th>
                                                <th scope="col">Saldo despues de pago</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for='(item,index) in datos.registro_pago_pendiente.pagos_realizados' :key=index>
                                                <th scope="row">{{index+1}}</th> 
                                                <td>{{item.fecha_creacion}}</td>
                                                <td>{{item.forma_pago}}</td>
                                                <td>
                                                    {{ formato_moneda(item.restante_antes_efectuar) }}
                                                </td>
                                                <td>{{ formato_moneda(item.cantidad) }}</td>
                                                <td>
                                                    {{ formato_moneda(item.restante_despues_efectuar) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <template v-if="datos.registro_pago_pendiente.mostrar_nuevo_pago">

                                    <div class="form-group col-md-12">
                                        <label for="inputEmail4">Nuevo pago:</label>
                                    </div>

                                    <div class="form-group col-md-2">
                                        <label for="inputEmail4">Fecha de creación:</label>
                                        <input type="date" class="form-control input-3d" v-model=datos.registro_pago_pendiente.nuevo_pago_fecha_creacion>
                                    </div> 

                                    <div class="form-group col-md-2">
                                        <label for="inputEmail4">Forma de pago:</label>
                                        <select class="form-control input-3d" v-model=datos.registro_pago_pendiente.forma_pago>
                                            <option value="" disabled>Seleccione</option>
                                            <option value="efectivo">Efectivo</option>
                                            <option value="transferencia">Transferencia</option>
                                        </select>
                                    </div>                                                            
                                   
                                    <div class="form-group col-md-6" v-if="datos.registro_pago_pendiente.forma_pago=='transferencia'">

                                        <label for="inputEmail4">Cuentas Disponibles :</label>                                    
                                        <select id="select_cuentas_disponibles" class="form-control input-3d" v-model=datos.registro_pago_pendiente.cuentas_bancarias_id>
                                            <option value="" disabled>Seleccione</option>
                                            <option v-for='(c,c_index) in datos.cuentas_bancarias.todos' :key=c_index :value="c.cuentas_bancarias_id">
                                                {{ c.banco_nombre }}
                                                {{ c.cuenta }}
                                                {{ c.titular }}
                                            </option>
                                        </select>
                                        
                                    </div>   
                                    <div class="form-group col-md-2">
                                        <label for="inputEmail4">Cantidad:</label>
                                        <input type="number" class="form-control input-3d" v-model=datos.registro_pago_pendiente.cantidad>
                                    </div>

                                </template>

                                
                            </div>                                                                                                                  

                        </div>
                    </div>
                    <div class="modal-footer">
                                                
                        <button v-if="datos.registro_pago_pendiente.mostrar_nuevo_pago" type="button" class="boton-3d-success" @click=enviar_datos_pago_pendiente>
                            Guardar pago
                        </button>  

                        <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>
        <!---fin modal pago_pendiente---->


    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
import * as calculos  from '@/librerias/lobato-calculos.js'
import PouchDB  from '@/librerias/pouchdb/pouchdb.min.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                _id:'',
                id:'',
                clientes_id:'',
                productos:[],
                total_venta:'',

                forma_pago:'',
                pago_pendiente:false,
                forma_pago_efe_tra_cant_efec:'',
                forma_pago_efe_tra_cant_tran:'',

                transferencias:[],

                fecha_creacion:'',
                tipo:'',
                descripcion:'',
                estado:''          
            },
            forma_pago_efec_tran_cantidad_valida:false,
            productos:{
                todos:[]
            },
            clientes:{
                todos:[]
            },
            cuentas_bancarias:{
                todos:[],
                seleccionado:''
            },
            registro_pago_pendiente:{
                pagos_realizados:[],
                total_venta:'',
                pago_pendiente_restante:'',
                no:'',
                fecha_creacion:'',
                descripcion:'',
                forma_pago:'',
                cantidad:'',
                cuentas_bancarias_id:'',
                mostrar_nuevo_pago:false,
                nuevo_pago_fecha_creacion:''
            },
            data_table:{
                cargando:false,
                registros:[]
            }
        }
    }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        regresar_selecionar_producto(index)
        {
            this.datos.registro.productos[index].productos_id='';
            this.actualizar_select_material(index,'');
        },
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                this.obtener_recursos();
                //this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        },  
        obtener_recursos()
        {
            this.datos.data_table.cargando=true;            
            fetch(`${this.general.otros.dominio_server}/ventas/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                let r=respuesta.datos;
                this.datos.productos.todos          =r.productos;
                this.datos.clientes.todos           =r.clientes;

                
                (r.cuentas_bancarias).forEach((item)=>{                    
                    item.id='';
                    item.seleccionado=false;
                    item.cantidad='';
                });
                this.datos.cuentas_bancarias.todos  =r.cuentas_bancarias;  

                this.data_table();

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
                this.datos.data_table.cargando=false;
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },

        cuenta_bancaria_seleccionado(c)
        {

            let id=c=='' ? this.datos.cuentas_bancarias.seleccionado : c.cuentas_bancarias_id;
            
            if(id!=='')
            {
                let a=this.datos.cuentas_bancarias.todos.find((e)=>e.cuentas_bancarias_id==id);
                console.log('a es');
                console.log(a);
                //if(a!==undefined)
                if(a===undefined)
                {
                    fetch(`${this.general.otros.dominio_server}/ventas/cuentas_bancarias/${id}/datos`,{
                        method:'GET',
                        //body:JSON.stringify( this.datos.registro ),
                        headers:{
                            'Accept'        :'application/json',
                            'Content-Type'  :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                        },
                        credentials: 'include',                   
                    })
                    .then(res=>res.json())
                    .then(respuesta=>{
                        
                        console.log('recursos');
                        console.log(respuesta);
                        if( (respuesta.datos).length>0 )
                        {
                            let d=respuesta.datos[0];
                            let banco_datos={
                                cuenta              :d.cuenta,
                                titular             :d.titular,
                                banco_nombre        :d.banco_nombre,
                                cuentas_bancarias_id:d.cuentas_bancarias_id
                            };
                            this.agregar_transferencia(c,banco_datos);
                        }
                    })
                    .catch(error=>{
                        //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
                        //this.datos.data_table.cargando=false;                
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;                
                    });

                }
                else
                {
                    /* this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
                    this.datos.registro.transferencias.push({
                        id          :c=='' ? '' : c.id,

                        cuenta      :a.cuenta,
                        titular     :a.titular,
                        banco_nombre:a.banco_nombre,

                        cuentas_bancarias_id    :c=='' ? a.cuentas_bancarias_id : c.cuentas_bancarias_id,
                        cantidad    :c=='' ? '' : c.cantidad,
                        estado      :'activo',
                        posicion    :''
                    }); */
                
                    this.agregar_transferencia(c,a);
                }            
                this.datos.cuentas_bancarias.seleccionado='';
            }
            

        },
        agregar_transferencia(c,a)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
            this.datos.registro.transferencias.push({
                id          :c=='' ? '' : c.id,

                cuenta      :a.cuenta,
                titular     :a.titular,
                banco_nombre:a.banco_nombre,

                cuentas_bancarias_id    :c=='' ? a.cuentas_bancarias_id : c.cuentas_bancarias_id,
                cantidad    :c=='' ? '' : c.cantidad,
                estado      :'activo',
                posicion    :''
            });
        },
        remover_transferencia(index)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.remover});
            this.datos.registro.transferencias[index].estado='inactivo';
        },


        /* 
        pago_pendiente_cuenta_bancaria_seleccionado(c)
        {

            let id=c=='' ? this.datos.cuentas_bancarias.seleccionado : c.cuentas_bancarias_id;
            
            if(id!=='')
            {
                let a=this.datos.cuentas_bancarias.todos.find((e)=>e.cuentas_bancarias_id==id);
                console.log('a es');
                console.log(a);

                if(a===undefined)
                {
                    fetch(`${this.general.otros.dominio_server}/ventas/cuentas_bancarias/${id}/datos`,{
                        method:'GET',
                        //body:JSON.stringify( this.datos.registro ),
                        headers:{
                            'Accept'        :'application/json',
                            'Content-Type'  :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                        },
                        credentials: 'include',                   
                    })
                    .then(res=>res.json())
                    .then(respuesta=>{
                        
                        console.log('recursos');
                        console.log(respuesta);
                        if( (respuesta.datos).length>0 )
                        {
                            let d=respuesta.datos[0];
                            let banco_datos={
                                cuenta              :d.cuenta,
                                titular             :d.titular,
                                banco_nombre        :d.banco_nombre,
                                cuentas_bancarias_id:d.cuentas_bancarias_id
                            };
                            this.pago_pendiente_agregar_transferencia(c,banco_datos);
                        }
                    })
                    .catch(error=>{
                        //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
                        //this.datos.data_table.cargando=false;                
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;                
                    });

                }
                else
                {                                    
                    this.pago_pendiente_agregar_transferencia(c,a);
                }            
                this.datos.cuentas_bancarias.seleccionado='';
            }
            

        },
        pago_pendiente_agregar_transferencia(c,a)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
            this.datos.registro_pago_pendiente.transferencias.push({
                id          :c=='' ? '' : c.id,

                cuenta      :a.cuenta,
                titular     :a.titular,
                banco_nombre:a.banco_nombre,

                cuentas_bancarias_id    :c=='' ? a.cuentas_bancarias_id : c.cuentas_bancarias_id,
                cantidad    :c=='' ? '' : c.cantidad,
                estado      :'activo',
                posicion    :''
            });
        },
        pago_pendiente_remover_transferencia(index)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.remover});
            this.datos.registro_pago_pendiente.transferencias[index].estado='inactivo';
        }, */


        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                
                if(p=='productos')
                {
                    this.datos.registro[p]=[];
                }
                else if(p=='transferencias')
                {
                    //this.asignar_cuentas();
                    this.datos.registro[p]=[];
                }
                else if(p=='forma_pago')
                {
                    this.datos.registro[p]='efectivo';
                }
                else if(p=='pago_pendiente')
                {
                    this.datos.registro[p]=false;
                }
                else if(p=='clientes_id')
                {
                    this.datos.registro[p]=21;
                }
                else
                {
                    this.datos.registro[p]='';
                }
                
            }      
            
            this.datos.registro.fecha_creacion=this.general_fecha_hoy;

            this.datos.registro.forma_pago_efe_tra_cant_efec='';
            this.datos.registro.forma_pago_efe_tra_cant_tran='';
            this.datos.forma_pago_efec_tran_cantidad_valida=false;

            this.datos.cuentas_bancarias.seleccionado='';
            
            /* (this.datos.cuentas_bancarias.todos).forEach((c)=>{
                c.seleccionado=false;
                c.cantidad='';
            }); */

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        data_table()
        {
            this.datos.data_table.cargando=true;            
            /* if(this.general.otros.app_modo=='offline')
            {                
                this.obtener_registros_offline();
            }   
            else if(this.general.otros.app_modo=='online')
            {  */               
                this.obtener_registros_offline();
            //}

            /*        
            fetch(`${this.general.otros.dominio_server}/ventas/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                }
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                this.datos.data_table.registros=respuesta.datos;                
                this.data_table_crear();
            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los clientes`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
            */

        },
        obtener_registros_offline()
        {
            this.datos.data_table.registros=[];
            let db = new PouchDB('metales_milenio_2024_ventas');            
            db.allDocs({include_docs: true})
            .then(doc=>{                

                let registros=[];
                //console.log('rows son ');
                //console.log(doc.rows);
                doc.rows.forEach((row)=>{

                    let doc=row.doc;
                    //console.log('docu es');
                    //console.log(doc)
                    if(!doc.sincronizado)
                    {
                        //this.datos.data_table.registros.push(doc);
                        doc.registro_origen='offline';
                        //console.log('registro local');
                        //console.log(doc);
                        //doc.id=doc._id;

                        registros.push(doc);
                    }

                });
                //this.datos.data_table.registros=this.datos.data_table.registros.reverse();
                //this.datos.data_table.registros=registros.reverse();
                registros=registros.reverse();
                registros.forEach((item)=>{
                    this.datos.data_table.registros.push(item);
                });
                if(this.general.otros.app_modo=='online')
                {                
                    this.obtener_registros_online();
                }
                else
                {
                    this.data_table_crear();
                    //this.datos.data_table.cargando=false;     
                }

            })
            .finally( () => {
                //this.datos.data_table.cargando=false;     

            });
        },
        obtener_registros_online()
        {
            fetch(`${this.general.otros.dominio_server}/ventas/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                //this.datos.data_table.registros=respuesta.datos;     
                (respuesta.datos).forEach((item)=>{
                    item.registro_origen='online';
                    item._id='';
                    this.datos.data_table.registros.push(item);
                });           
                this.data_table_crear();
            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los clientes`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },
        data_table_crear()
        {
            this.datos.data_table.cargando=false;                
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Cliente</th>
                            <th>Total venta</th>
                            <th>Fecha creación</th>
                            <th>Estado</th>
                            <th>Tipo de venta</th>
                            <th>Venta pendiente</th>
                            <th style="width:25%;">Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>No</th>
                            <th>Cliente</th>
                            <th>Total venta</th>
                            <th>Fecha creación</th>
                            <th>Estado</th>
                            <th>Tipo de venta</th>
                            <th>Venta pendiente</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                if(title=='Venta pendiente')
                {
                    $(this).html( `
                        <select class="form-control" style="width:100%;font-size:11px;">
                            <option value="">Todos</option>
                            <option value="si">si</option>
                            <option value="no">no</option>
                        </select>
                    `);
                }
                else
                {
                    $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
                }

                $( 'input', this ).on( 'input', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );

                $( 'select', this ).on( 'change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
                
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {
                            //return data.no;
                            let no='';
                            if(data.registro_origen=='online')                 
                            {
                                no=data.no;
                            }
                            return  no;
                        }
                    }, 
                    {"targets":1, "data":(data,type,full,meta)=>
                        {
                            /* let a={
                                nombre:[null,''].includes(data.nombre) ? '' : data.nombre,
                                apellido_p:[null,''].includes(data.apellido_paterno) ? '' : data.apellido_paterno,
                                apellido_m:[null,''].includes(data.apellido_materno) ? '' : data.apellido_materno
                            };
                            return `${a.nombre} ${a.apellido_p} ${a.apellido_m}`; */
                            if(data.registro_origen=='online')
                            {
                                let a={
                                    nombre:[null,''].includes(data.nombre) ? '' : data.nombre,
                                    apellido_p:[null,''].includes(data.apellido_paterno) ? '' : data.apellido_paterno,
                                    apellido_m:[null,''].includes(data.apellido_materno) ? '' : data.apellido_materno
                                };
                                return `${a.nombre} ${a.apellido_p} ${a.apellido_m}`;
                            }
                            else if(data.registro_origen=='offline')
                            {
                                let c=(this.datos.clientes.todos).find((e)=>e.id==data.clientes_id);
                                //console.log('CLIENTE----------------------------------------');
                                //console.log(c);
                                if(c!==undefined)
                                {
                                    let a={
                                        nombre      :[null,''].includes(c.nombre) ? '' : c.nombre,
                                        apellido_p  :[null,''].includes(c.apellido_paterno) ? '' : c.apellido_paterno,
                                        apellido_m  :[null,''].includes(c.apellido_materno) ? '' : c.apellido_materno
                                    };
                                    return `${a.nombre} ${a.apellido_p} ${a.apellido_m}`;
                                }
                                else
                                {
                                    return '';
                                }
                            }
                            else
                            {
                                return '';
                            }
                        }
                    },                    
                    {"targets":2, "data":(data,type,full,meta)=>
                        {
                            return this.formato_moneda(data.total_venta);
                        }   
                    },
                    {"targets":3, "data":(data,type,full,meta)=>
                        {
                            return data.fecha_creacion;                           
                        }   
                    },
                    {"targets":4, "data":(data,type,full,meta)=>
                        {
                            //return data.estado;                          
                            if(data.registro_origen=='online')
                            {
                                let estado=data.estado;
                                if(data.pago_pendiente=='si' && data.estado=='finalizado' && calculos.revisar_numero(data.pago_pendiente_restante )>0)
                                {
                                    estado=estado+'<br> (Pago pendiente) ';                                    
                                }

                                return estado;
                            }
                            else if(data.registro_origen=='offline')
                            {
                                return 'no guardado';
                            }
                            else
                            {
                                return '';
                            }
                        }   
                    },
                    {"targets":5, "data":(data,type,full,meta)=>
                        {
                            return data.tipo;                          
                        }   
                    },
                    {"targets":6, visible:false, "data":(data,type,full,meta)=>
                        {   
                            let pp=''; 
                            if(data.registro_origen=='online')                        
                            {
                                pp=data.pago_pendiente=='si' ? 'si' : 'no';                                   
                            }
                            else if(data.registro_origen=='offline')
                            {
                                pp=data.pago_pendiente ? 'si' : 'no';
                            }
                            //return data.pago_pendiente=='si' ? 'si' : 'no';
                            return pp;
                        }   
                    },
                    {"targets":7, "data":(data,type,full,meta)=>
                        {
                            var acciones=``;
                            if(data.registro_origen=='online')
                            {  
                                let boton_editar_ver='';
                                if(data.estado=='activo')
                                {
                                    boton_editar_ver=`
                                        <i registro-id='${data.id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                        Editar
                                    `;
                                }
                                else
                                {
                                    boton_editar_ver=`
                                        <i registro-id='${data.id}' class="fa fa-eye" aria-hidden="true"></i>
                                        Ver
                                    `;
                                }                                

                                acciones+=`
                                    <a href="${this.general.otros.dominio}/#/ventas/${data.id}/ticket" target="_blank" class="boton-3d-info" style="margin-right:1em;">
                                        Ticket
                                    </a>
                                `;

                                /* if( ['no',null].includes(data.pago_pendiente) || (data.pago_pendiente=='si' && data.estado=='activo' ) )
                                { */
                                    acciones+=`
                                        <button registro-id='${data.id}' registro-no='${data.no}' class="boton-modal-remover boton-3d-danger" style="margin-right:1em;">
                                            <i registro-id='${data.id}' registro-no='${data.no}' class='fa fa-times' aria-hidden='true'></i>                                    
                                        </button>
                                    `;
                                //}

                                acciones+=`
                                    <button registro-id='${data.id}' class="boton-modal-editar-registro boton-3d-success" style="margin-right:1em;">                                    
                                        ${boton_editar_ver}
                                    </button>                                                                                                            
                                `;

                                if(data.pago_pendiente=='si' && data.estado=='finalizado')
                                {
                                    acciones+=`
                                        <button registro-id='${data.id}' class="boton_modal_pago_pendiente boton-3d-info" style="margin-right:1em;">
                                            Pagos
                                        </button>
                                    `;
                                }
                            }
                            else if(data.registro_origen=='offline')
                            {
                                acciones+=`
                                    <a href="${this.general.otros.dominio}/#/ventas/local_${data._id}/ticket" target="_blank" class="boton-3d-info" style="margin-right:1em;">
                                        Ticket
                                    </a>
                                    <button registro-id='${data._id}' class="boton-modal-editar-registro-offline boton-3d-success" style="margin-right:1em;">
                                        <i registro-id='${data._id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                        Editar
                                    </button>                                    
                                `;

                            } 

                            return `
                                <div style="display:flex; justify-content:left; align-items:center;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton-modal-editar-registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });

            Array.from(document.getElementsByClassName("boton-modal-remover")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover);
            });

            Array.from(document.getElementsByClassName("boton-modal-editar-registro-offline")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_offline_evento);
            });            
            Array.from(document.getElementsByClassName("boton_modal_pago_pendiente")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_pago_pendiente);
            });
            
            /* Array.from(document.getElementsByClassName("boton-modal-eliminar")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_eliminar);
            }); */
        },
        boton_modal_pago_pendiente(item)
        {
            this.datos.registro_cargando=true;
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal_pago_pendiente").modal("show");            
            this.obtener_informacion_pago_pendiente();
        },
        obtener_informacion_pago_pendiente()
        {
            for (let p in this.datos.registro_pago_pendiente) {                                                               
                if(p=='pagos_realizados')
                {
                    this.datos.registro_pago_pendiente[p]=[];
                }
                else if(p=='transferencias')
                {
                    this.datos.registro_pago_pendiente[p]=[];
                }
                else if(p=='mostrar_nuevo_pago')
                {
                    this.datos.registro_pago_pendiente[p]=false;
                }
                else
                {
                    this.datos.registro_pago_pendiente[p]='';
                }
            }
            this.datos.registro_pago_pendiente.nuevo_pago_fecha_creacion=this.general_fecha_hoy;


            fetch(`${this.general.otros.dominio_server}/ventas/${this.datos.registro.id}/pago_pendiente/datos`,{
                method:'get',                
                headers:{                    
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{

                console.log('datos venta');
                console.log(respuesta);

                if(respuesta.datos.venta.length>0)
                {
                    let r =respuesta.datos.venta[0];

                    let pp=this.datos.registro_pago_pendiente;
                    
                    pp.descripcion              =r.descripcion;
                    pp.fecha_creacion           =r.fecha_creacion;
                    pp.no                       =r.no;
                    pp.total_venta              =r.total_venta;
                    pp.pago_pendiente_restante  =calculos.revisar_numero(r.pago_pendiente_restante);

                    pp.mostrar_nuevo_pago       =pp.pago_pendiente_restante>0 ? true : false;

                    pp.pagos_realizados         =r.pagos_realizados;

                }

            })
            .catch(error=>{

            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
        },
        boton_modal_editar_registro_offline_evento(item)
        {
            this.boton_modal_registro();  
            ///this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;  
            this.datos.registro.fecha_creacion='';  
            this.datos.registro.forma_pago='';  
            this.datos.registro.clientes_id='';

            let _id=calculos.atributo(item,'registro-id');
            let r=this.datos.data_table.registros.find( (e)=> e._id==_id );
            console.log('compra offline es');
            console.log(r);
            if(r!=undefined)
            {
                let c=this.datos.registro;
                /*
                c._id                         =_id;
                c.id                          =r.id;
                c.clientes_id                 =r.clientes_id;
                c.fecha_creacion              =r.fecha_creacion;
                c.prestamos                   =r.prestamos;
                c.productos                   =r.productos;
                c.total_compra_pre1           =r.total_compra_pre1;
                c.total_compra                =r.total_compra;
                c.forma_pago                  =r.forma_pago;
                c.forma_pago_efe_tra_cant_efec=r.forma_pago_efe_tra_cant_efec;
                c.forma_pago_efe_tra_cant_tran=r.forma_pago_efe_tra_cant_tran;
                c.estado                      =r.estado;  
                */              
                c._id               =_id;
                c.id                =r.id;
                c.clientes_id       =r.clientes_id;
                c.fecha_creacion    =r.fecha_creacion;
                c.tipo              =r.tipo;
                c.descripcion       =r.descripcion;
                c.productos         =r.productos;
                c.total_venta       =r.total_venta;

                c.forma_pago                  =r.forma_pago;
                c.forma_pago_efe_tra_cant_efec=r.forma_pago_efe_tra_cant_efec;
                c.forma_pago_efe_tra_cant_tran=r.forma_pago_efe_tra_cant_tran;
                c.transferencias    =r.transferencias;
                c.pago_pendiente    =r.pago_pendiente;

                c.estado            =r.estado;

                //this.cliente_seleccionado('db');                

                this.calcular_forma_pago_efec_tran_total();
            }
            this.datos.registro_cargando=false;  
        },
        boton_modal_remover(item)
        {
            //this.datos.registro.i
            let dt={
                id:calculos.atributo(item,'registro-id'),
                no:calculos.atributo(item,'registro-no')
            };
            Swal.fire({
                title: `¿ Remover venta no : ${dt.no} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/ventas/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            ventas_id:dt.id,
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        //console.log(res);
                        //console.log('Estado de la respuesta:', res.status);
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }

                        //return res.json();
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                this.data_table();
                                $("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Venta removida`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`La venta no se pudo remover`});
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;  
            this.datos.registro.fecha_creacion='';        
            //fetch(`${this.general.otros.dominio}/productos/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/ventas/${this.datos.registro.id}/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{

                if(respuesta.datos.venta.length>0)
                {
                    let r=respuesta.datos.venta[0];

                    this.datos.registro.clientes_id     =r.clientes_id;
                    this.datos.registro.fecha_creacion  =r.fecha_creacion;
                    this.datos.registro.tipo            =r.tipo;
                    this.datos.registro.descripcion     =r.descripcion;
                    this.datos.registro.total_venta     =r.total_venta;
                    this.datos.registro.estado          =r.estado;
                    this.datos.registro.forma_pago      =r.forma_pago;
                    this.datos.registro.forma_pago_efe_tra_cant_efec=r.forma_pago_efe_tra_cant_efec;
                    this.datos.registro.forma_pago_efe_tra_cant_tran=r.forma_pago_efe_tra_cant_tran;
                    this.datos.registro.pago_pendiente  =r.pago_pendiente=='si' ? true : false;

                    r.productos.forEach((item,index)=>{
                        this.agregar_producto(item);
                    });

                    r.transferencias.forEach((item,index)=>{
                        this.cuenta_bancaria_seleccionado(item);                        
                    });

                    this.calcular_forma_pago_efec_tran_total();
                }

            })
            .catch(error=>{

            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },                
        agregar_producto(p)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
            this.datos.registro.productos.push({
                id          :p==='' ? '' : p.id,
                productos_id:p==='' ? '' : p.productos_id,
                precio      :p==='' ? '' : p.precio,
                cantidad    :p==='' ? '' : p.cantidad,
                total       :p==='' ? '' : p.total,
                origen      :p==='' ? '' : p.origen,
                posicion    :'',
                estado      :'activo'
            });
            this.productos_ordenar_posiciones();
            this.actualizar_select_material(this.datos.registro.productos.length-1,p);
            this.desactivar_scroll_cantidad_precio(this.datos.registro.productos.length-1);
        },
        boton_remover_producto(index)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.remover});
            this.datos.registro.productos[index].estado='inactivo';
            this.productos_ordenar_posiciones();
            this.calcular_registro_venta_total();
        },
        productos_ordenar_posiciones()
        {            
            let a=0;
            this.datos.registro.productos.forEach((item,index)=>{
                
                if(item.estado=='activo')
                {
                    a++;
                    item.posicion=a;
                }

            });
        },

        ////////////////
        material_seleccionado(index)
        {
            /* let p=this.datos.registro.productos[index];
            let a=(this.datos.productos.todos).find((e)=>e.id==p.productos_id);
            p.precio=a===undefined ? 0 : a.precio;
            this.calcular_producto_total(index); */

            document.getElementById('input_cantidad_'+index).focus();
        },
        calcular_producto_total(index)
        {
            let p=this.datos.registro.productos[index];
            p.total=calculos.calcular_multiplicacion([
                p.precio,
                p.cantidad
            ]);
            p.total=(p.total).toFixed(2);
            this.calcular_registro_venta_total();
        },
        calcular_registro_venta_total()
        {
            let r=this.datos.registro;
            r.total_venta=0;

            (r.productos).forEach((p,index)=>{

                if(p.estado=='activo')
                {                                    
                    r.total_venta=calculos.calcular_suma([
                        r.total_venta,
                        p.total
                    ]);
                }
            });
            console.log(this.datos.registro);
        },
        guardar_localmente()
        {
            let r=this.datos.registro;            
            let db = new PouchDB('metales_milenio_2024_ventas');
            
            if(r._id==='')
            {
                let registro = {
                    _id: new Date().toISOString(),
                    sincronizado: false,

                    /* id                          :r.id,
                    clientes_id                 :r.clientes_id,
                    fecha_creacion              :r.fecha_creacion,
                    prestamos                   :r.prestamos,
                    productos                   :r.productos,
                    total_compra_pre1           :r.total_compra_pre1,
                    total_compra                :r.total_compra,
                    forma_pago                  :r.forma_pago,
                    forma_pago_efe_tra_cant_efec:r.forma_pago_efe_tra_cant_efec,
                    forma_pago_efe_tra_cant_tran:r.forma_pago_efe_tra_cant_tran,
                    estado                      :r.estado   */              
                    id              :r.id,
                    clientes_id     :r.clientes_id,
                    fecha_creacion  :r.fecha_creacion,
                    tipo            :r.tipo,
                    descripcion     :r.descripcion,
                    productos       :r.productos,
                    total_venta     :r.total_venta,

                    forma_pago      :r.forma_pago,
                    forma_pago_efe_tra_cant_efec :r.forma_pago_efe_tra_cant_efec,
                    forma_pago_efe_tra_cant_tran :r.forma_pago_efe_tra_cant_tran,
                    pago_pendiente  :this.datos.registro.pago_pendiente,
                    transferencias  :r.transferencias,

                    estado          :r.estado                
                };

                db.put(registro).then( () => {                                                
                
                    this.data_table();
                    this.funciones({nombre:'alerta',estatus:'success',mensaje:`Venta guardada localmente`});
                    $("#modal-registro").modal("hide");                        
                    
                });
            }
            else
            {
                db.get(r._id)
                .then( (doc) => {                
                    //doc.sincronizado=false;

                    /* doc.id                          =r.id;
                    doc.clientes_id                 =r.clientes_id;
                    doc.fecha_creacion              =r.fecha_creacion;
                    doc.prestamos                   =r.prestamos;
                    doc.productos                   =r.productos;
                    doc.total_compra_pre1           =r.total_compra_pre1;
                    doc.total_compra                =r.total_compra;
                    doc.forma_pago                  =r.forma_pago;
                    doc.forma_pago_efe_tra_cant_efec=r.forma_pago_efe_tra_cant_efec;
                    doc.forma_pago_efe_tra_cant_tran=r.forma_pago_efe_tra_cant_tran; */
                    doc.id              =r.id;
                    doc.clientes_id     =r.clientes_id;
                    doc.fecha_creacion  =r.fecha_creacion;
                    doc.tipo            =r.tipo;
                    doc.descripcion     =r.descripcion;
                    doc.productos       =r.productos;
                    doc.total_venta     =r.total_venta;
                    
                    doc.forma_pago      =r.forma_pago;
                    doc.forma_pago_efe_tra_cant_efec =r.forma_pago_efe_tra_cant_efec;
                    doc.forma_pago_efe_tra_cant_tran =r.forma_pago_efe_tra_cant_tran;
                    doc.transferencias  =r.transferencias;

                    doc.estado          =r.estado;

                    db.put(doc)
                    .then( () => {
                        //this.data_table_movilidad();
                        this.data_table();
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Venta guardada localmente`});
                        $("#modal-registro").modal("hide");                        
                    });

                });  
            }            
        },

        enviar_datos(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  

            let enviar=false;
            //let veri_origen=false;
            let veri_transferencias=false;

            if(this.datos.registro.pago_pendiente)
            {
                enviar=true;
                //veri_origen=true;
                veri_transferencias=true;
            }
            else
            {
                if(a=='finalizar')
                {
                    if(this.datos.registro.forma_pago=='efectivo_transferencia' && this.datos.forma_pago_efec_tran_cantidad_valida)
                    {       
                        /*
                            este if verifica que si la forma de pago es efectivo junto con
                            transferencia, las suma de las cantidades en efectivo y transferencia
                            sean igual al total final de la compra
                        */             
                        enviar=true;
                    }
                    else if(['efectivo','transferencia'].includes(this.datos.registro.forma_pago))
                    {
                        
                        enviar=true;                    
                    }

                    //let ori=this.datos.registro.productos.find((e)=> ! ['compras','bodega'].includes(e.origen) );
                    
                    //veri_origen=ori===undefined ? true : false;

                    if( this.datos.registro.forma_pago=='transferencia')
                    {
                        let transferencias_activas=(this.datos.registro.transferencias).filter( (e)=>e.estado=='activo' );

                        let trans_total=0;
                        transferencias_activas.forEach((t,index)=>{
                            trans_total=calculos.calcular_suma([
                                trans_total,
                                t.cantidad
                            ]);
                        });
                        veri_transferencias=trans_total==this.datos.registro.total_venta ? true : false;
                    }
                    else if(this.datos.registro.forma_pago=='efectivo_transferencia')
                    {
                        let transferencias_activas=(this.datos.registro.transferencias).filter( (e)=>e.estado=='activo' );

                        let trans_total=0;
                        transferencias_activas.forEach((t,index)=>{
                            trans_total=calculos.calcular_suma([
                                trans_total,
                                t.cantidad
                            ]);
                        });

                        let forma_pago_efe_tra_cant_tran=calculos.revisar_numero(this.datos.registro.forma_pago_efe_tra_cant_tran);
                        veri_transferencias=trans_total==forma_pago_efe_tra_cant_tran ? true : false;

                    }
                    else if(this.datos.registro.forma_pago=='efectivo')
                    {
                        veri_transferencias=true;
                    }



                }
                else
                {
                    enviar=true;
                    //veri_origen=true;
                    veri_transferencias=true;
                }
            }

            //if(enviar && veri_origen && veri_transferencias)
            if(enviar && veri_transferencias)
            {

                this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                
                let p=this.datos.registro.productos.filter((e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!='') );                

                let transferencias=(this.datos.registro.transferencias).filter( (e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!=='' ) );                
                
                fetch(`${this.general.otros.dominio_server}/ventas/registro`,{
                    method:'POST',
                    body:JSON.stringify( {
                        accion          :a,
                        id              :this.datos.registro.id,
                        clientes_id     :this.datos.registro.clientes_id,
                        fecha_creacion  :this.datos.registro.fecha_creacion,
                        tipo            :this.datos.registro.tipo,
                        descripcion     :this.datos.registro.descripcion,
                        productos       :p,
                        total_venta     :this.datos.registro.total_venta,
                        forma_pago      :this.datos.registro.forma_pago,
                        forma_pago_efe_tra_cant_efec :this.datos.registro.forma_pago_efe_tra_cant_efec,
                        forma_pago_efe_tra_cant_tran :this.datos.registro.forma_pago_efe_tra_cant_tran,
                        pago_pendiente  :this.datos.registro.pago_pendiente ? 'si' : 'no',
                        transferencias  :transferencias
                    } ),
                    headers:{                    
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                        'Content-Type'  :'application/json',
                        'Accept'        :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                    },
                    credentials: 'include',                   
                })
                .then(res => {
                    //console.log(res);
                    //console.log('Estado de la respuesta:', res.status);
                    if (res.status == 200) 
                    {
                        return res.json();
                    }
                    else
                    {
                        throw new Error(`Error: ${res.status}`);
                    }

                    //return res.json();
                })
                //.then(res=>res.json())
                .then(respuesta=>{
                    console.log('respuesta es');
                    console.log(respuesta);
                    let dt={
                        'bien':()=>{                        
                            //this.data_table();
                            //$("#modal-registro").modal("hide");
                            //this.funciones({nombre:'alerta',estatus:'success',mensaje:`Venta ${this.datos.registro.id=='' ? 'creada' : 'editada'}`});
                            /*en caso de que el registro que se guardo 
                            era un registro offline*/
                            if(this.datos.registro._id!=='')
                            {   
                                this.registro_offline_sincronizado();
                            }
                            else
                            {
                                this.data_table();
                                $("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Venta ${this.datos.registro.id=='' ? 'creada' : 'editada'}`});
                            }  
                        }
                    };

                    if(respuesta.mensaje in dt )
                    {
                        dt[respuesta.mensaje]();
                    }                
                })
                .catch(error=>{
                    console.log('error es');
                    console.log(error);
                    this.funciones({nombre:'alerta',estatus:'error',mensaje:`La venta no se pudo ${this.datos.registro.id=='' ? 'crear' : 'editar'}`});
                })
                .finally( () => {
                    //this.datos.data_table.cargando=false;
                });
            }
            else
            {
                if(enviar==false)
                {
                    this.funciones({
                        nombre:'alerta',estatus:'error',
                        mensaje:`
                            La venta no puede finalizar porque las cantidades de 
                            efectivo y transferencia no coinciden con el total final
                        `
                    });
                }

                /*if(veri_origen==false)
                {
                    this.funciones({
                        nombre:'alerta',estatus:'error',
                        mensaje:`
                            La venta no puede finalizar porque todos los materiales deben
                            tener un origen
                        `
                    });
                }*/

                if(veri_transferencias==false)
                {
                    this.funciones({
                        nombre:'alerta',estatus:'error',
                        mensaje:`
                            La venta no puede finalizar porque las transferencias no coinciden
                        `
                    });
                }
            }

        },
        registro_offline_sincronizado()
        {            
            let db = new PouchDB('metales_milenio_2024_ventas');
            db.get(this.datos.registro._id)
            .then( (doc) => {                
                doc.sincronizado=true;
                //db.put(doc);
                db.put(doc)
                .then( () => {
                    //this.data_table_movilidad();
                    this.data_table();
                    $("#modal-registro").modal("hide");
                    this.funciones({nombre:'alerta',estatus:'success',mensaje:`Venta ${this.datos.registro.id=='' ? 'creada' : 'editada'}`});
                });
            })  
        },
        formato_moneda(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        },
        actualizar_select_material(index,p)
        {
            let id_intervalo=setInterval(()=>{

                let c=document.getElementById(`select_material_${index}`)==null ? 0 : document.getElementById(`select_material_${index}`).options.length;

                let dt={
                    //a:document.getElementById(`select_material_${index}`).options.length>0 ? ,
                    a:c,
                    b:((this.datos.productos.todos).length)+1    
                };
                /* console.log('here buscador');
                console.log(dt.a);
                console.log(dt.b);
                console.log('-------------------'); */

                if(dt.a==dt.b)
                {
                    $(`#select_material_${index}`).selectpicker();
                    $(`#select_material_${index}`).selectpicker('refresh');
                    clearInterval(id_intervalo);
                    if(p==='')
                    {                        
                        document.getElementById(`select_material_${index}`).focus();
                    }
                    else
                    {
                        document.getElementById(`input_cantidad_${index}`).focus();
                    }
                    
                }

            },100);
        },
        desactivar_scroll_cantidad_precio(index)
        {
            let id_intervalo=setInterval(()=>{

                //let c=document.getElementById(`input_cantidad_${index}`)==null ? 0 : document.getElementById(`select_material_${index}`).options.length;                

                if(document.getElementById(`input_cantidad_${index}`)!==null)
                {                    
                    let input = document.getElementById(`input_cantidad_${index}`);
                    input.addEventListener("wheel", function(event) {
                        console.log('evento here');
                        event.preventDefault(); // evita que el scroll cambie el valor
                    });
                    clearInterval(id_intervalo);                    
                }

            },100);

            let id_intervalo2=setInterval(()=>{

                //let c=document.getElementById(`input_cantidad_${index}`)==null ? 0 : document.getElementById(`select_material_${index}`).options.length;                

                if(document.getElementById(`precio_cantidad_${index}`)!==null)
                {                    
                    let input2 = document.getElementById(`precio_cantidad_${index}`);
                    input2.addEventListener("wheel", function(event) {
                        console.log('evento here');
                        event.preventDefault(); // evita que el scroll cambie el valor
                    });
                    clearInterval(id_intervalo2);                    
                }

            },100);
        },
        cantidad_evento_key($event,index)
        {
            /*console.log('tecla 3');
            if(event.key=='Enter')
            {
                this.agregar_producto('');
            }*/
            console.log('tecla 3');
            if($event.key=='Enter')
            {
                //this.agregar_producto('');
                document.getElementById(`precio_cantidad_${index}`).focus();
            }

        },
        precio_evento_key(event)
        {
            /*console.log('tecla 3');
            if($event.key=='Enter')
            {
                //this.agregar_producto('');
                document.getElementById(`input_cantidad_${index}`).focus();
            }*/
            console.log('tecla 3');
            if(event.key=='Enter')
            {
                this.agregar_producto('');
            }
        },
        calcular_forma_pago_efec_tran_total()
        {
            //this.datos.forma_pago_efec_tran_cantidad_valida
            let c=calculos.calcular_suma([
                this.datos.registro.forma_pago_efe_tra_cant_efec,
                this.datos.registro.forma_pago_efe_tra_cant_tran,
            ]);
            if(this.datos.registro.total_venta==c)
            {
                this.datos.forma_pago_efec_tran_cantidad_valida=true
            }
            else
            {
                this.datos.forma_pago_efec_tran_cantidad_valida=false;
            }
        },
        forma_pago_seleccionado()
        {
            this.datos.registro.forma_pago_efe_tra_cant_efec='';
            this.datos.registro.forma_pago_efe_tra_cant_tran='';
            this.datos.forma_pago_efec_tran_cantidad_valida=false;

            this.datos.registro.transferencias=[];
        },
        enviar_datos_pago_pendiente()
        {
            let r=this.datos;
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
            fetch(`${this.general.otros.dominio_server}/ventas/*/pago_pendiente/registro`,{
                method:'POST',
                body:JSON.stringify( {
                    ventas_id           :r.registro.id,
                    fecha_creacion      :r.registro_pago_pendiente.nuevo_pago_fecha_creacion,
                    forma_pago          :r.registro_pago_pendiente.forma_pago,
                    cantidad            :r.registro_pago_pendiente.cantidad,
                    cuentas_bancarias_id:r.registro_pago_pendiente.cuentas_bancarias_id
                } ),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res => {
                //console.log(res);
                //console.log('Estado de la respuesta:', res.status);
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }

                //return res.json();
            })
            //.then(res=>res.json())
            .then(respuesta=>{
                console.log('respuesta es');
                console.log(respuesta);
                let dt={
                    'bien':()=>{                                         
                        this.obtener_informacion_pago_pendiente();
                        this.data_table();
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Guardado`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                console.log('error es');
                console.log(error);
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`Pagos no se pudo guardar `});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        }
    },
    computed: {
        ...mapState(['general']),
        ...mapGetters([
            'general_fecha_hoy',
            'general_no_xss',
            'general_formato_moneda'
        ]),
        /* ...mapGetters(['formatear_moneda']),
        formato_moneda(m)
        {
            this.formatear_moneda(m);
        } */
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
    #leyenda-metodo-pago-ambos-rojo{
        color:red;
    }
    #leyenda-metodo-pago-ambos-verde{
        color:green;
    }

    .contenedor-check-cantidad{
        width:100%; 
        display:flex; 
        flex-wrap:wrap; 
        align-items:center; 
        input{
            width:45%;
        }
    }

    #contenedor-pago-posteriomente{
        width:100%;
        display:flex;
        flex-wrap:wrap;
        align-items:center;            
        justify-content:right;
        padding-right:4%;
        input{
            width:30px;
            margin-right:1em;
        }
        p{
            margin:0px;
        }
    }

    #select_cuentas_disponibles{
        option{
            text-align:left;
        }
    }
    
    .material-nombre{
        color:white; 
        text-align:center; 
        margin:0px; 
        font-size:1em;
        cursor:pointer;
        &:hover{
            background:red;
            border-radius:7px;
            padding:0.5em;
        }
    }
    
    .titulo-campo{
        width:100%;
        text-align:center;
    }
</style>